import { Injectable } from '@angular/core';
import { AbstractSignalForm } from '@core/forms/signal-form';
import { FieldTree, required, SchemaPathTree } from '@angular/forms/signals';


export interface ChangeInvoiceStatusFormData {
    [FormChangeInvoiceStatusFormField.StCode]: number;
}

export enum FormChangeInvoiceStatusFormField {
    StCode = 'stCode',
}

@Injectable()
export class ChangeInvoiceStatusFormService extends AbstractSignalForm<FormChangeInvoiceStatusFormField, ChangeInvoiceStatusFormData> {
    public createSignalForm(): FieldTree<ChangeInvoiceStatusFormData> {
        this.createFormModel({
            [FormChangeInvoiceStatusFormField.StCode]: null,
        });

        this.build((path: SchemaPathTree<ChangeInvoiceStatusFormData>) => {
            required(path.stCode);
        });

        return this.form;
    }
}
